import './cancel-parts-order.modal.scss';

export default function CancelPartsOrderModal($scope, $t, close, config, $alert) {
  'ngInject';

  $scope.cancellationInfo = config;

  $scope.ok = (form) => {
    if (!$scope.cancellationInfo.reason) {
      $alert.error($t('shared.modals.cancel_parts_order.reason_required_error'));
      return;
    }

    if (form.$valid) {
      const result = {cancellationReason: $scope.cancellationInfo.reason};

      close(result);
    }
  }

  $scope.close = () => {
    close(false);
  }
}